import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as Axios from "axios";
import { useDebounce } from "use-debounce";
import { Box, InputAdornment } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import "./SearchSelectFilter.css";

export default function SearchSelectFilter(props) {
  const {
    filters,
    setFilters,
    id,
    sourceId,
    setSourceId,
    module,
    multiple,
    placeholder,
    url,
    disabled,
    arrayList,
  } = props;
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [searchBy, setSearchBy] = useState("");

  const [debouncedText] = useDebounce(searchBy, 350);
  let loading = false;

  const onChangeHandle = (value) => {
    setSearchBy(value);
  };

  const makeData = (data) => {
    let list = [];
    if (
      module === "jobListing" ||
      module === "tcsCityListing" ||
      module === "tcsCenterListing"
    ) {
      data.map((el) => {
        if (
          module === "jobListing" &&
          el.city_id !== null &&
          el.city_id !== ""
        ) {
          list.push({
            id: el.city_id,
            name: el.cityName,
          });
        } else {
          list.push({
            id: el.name,
            name: el.name,
          });
        }
        return true;
      });
    } else if (module === "preferredPincodesListing") {
      data.map((el) => {
        if (el.distinct_city_id !== null && el.pin !== "") {
          list.push({
            id: el.pin,
            name: el.pin.toString(),
          });
        }
        return true;
      });
    } else if (
      module === "managedByModalListing" ||
      module === "managedByListing"
    ) {
      data.map((el) => {
        if (el?.Email !== null && el?.Email !== "") {
          if (!filters.managedBy_addMember.includes(el.Email)) {
            list.push({
              id: el.Email,
              name: el.Name,
            });
          }
        }
        return true;
      });
    } else {
      data.content.map((el) => {
        if (el !== null && el !== "") {
          if (
            (module === "leadCityListing" && !filters.leadCity.includes(el)) ||
            (module === "driveExamCityListing" &&
              !filters.examCity.includes(el)) ||
            (module === "invigilatorCityNameListing" &&
              !filters.city.includes(el)) ||
            (module === "attendanceCityListing" && !filters.city.includes(el))
          ) {
            list.push({
              id: el,
              name: el,
            });
          }
        }
        return true;
      });
    }
    return list;
  };

  const getOptionsData = () => {
    if (module === "tcsCityListing" || module === "tcsCenterListing") {
      let filteredData = arrayList.filter((item) =>
        item.name.toLowerCase().includes(debouncedText.toLowerCase())
      );
      setOptions(makeData(filteredData));
      return;
    }
    if (debouncedText) {
      loading = true;
      Axios.get(`${url}${debouncedText}`)
        .then((response) => {
          setOptions(makeData(response.data.response));
          loading = false;
        })
        .catch((err) => console.log(err));
    }
  };

  const handleValue = (val) => {
    let list = [];
    if (module === "jobListing" || module === "managedByModalListing") {
      list.push(val?.id);
    } else {
      val.map((e) => {
        list.push(e.id);
      });
    }
    return list;
  };

  useEffect(() => {
    getOptionsData();
  }, [debouncedText]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      id="multiple-limit-tags"
      multiple={multiple}
      limitTags={1}
      freeSolo
      value={sourceId}
      onChange={(event, value) => {
        let a = handleValue(value);
        setFilters({
          ...filters,
          [id]: module === "jobListing" ? a : a.toString(),
        });
        setSourceId(
          typeof value === "string" && module !== "managedByModalListing"
            ? value.split(",")
            : value
        );
      }}
      disabled={disabled}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      loading={loading}
      style={{ width: module === "managedByModalListing" ? "95%" : "250px" }}
      options={options}
      getOptionLabel={(option) =>
        module === "managedByModalListing" || module === "managedByListing"
          ? option.id || ""
          : option.name || ""
      }
      // Ensure spaces in search input do not break filtering
      filterOptions={(opts, { inputValue }) => {
        const searchTerm = inputValue.trim().toLowerCase();
        return opts.filter(
          (opt) =>
            opt.name.toLowerCase().includes(searchTerm) ||
            opt.id.toString().includes(searchTerm)
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder={
            sourceId == "" || sourceId == null || sourceId?.length === 0
              ? placeholder
              : ""
          }
          size="small"
          onChange={(event) => {
            if (event.target.value !== "" || event.target.value !== null) {
              onChangeHandle(event.target.value);
            }
          }}
          className={
            // (sourceId != "" || sourceId != null || sourceId?.length > 0) && module !== "jobListing"
            //   ? "ZeroPadding"
            //   : "DefaultPadding"
            `DefaultPadding ${
              module === "managedByModalListing" ? "disableStyle" : ""
            }`
          }
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <div>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {sourceId == "" || sourceId == null ? (
                  <InputAdornment position="end" edge="end">
                    <SearchIcon
                      edge="end"
                      style={{ color: "#A7A7A7", marginRight: "-35px" }}
                    />
                  </InputAdornment>
                ) : (
                  <InputAdornment position="end" edge="end">
                    {params.InputProps.endAdornment}
                  </InputAdornment>
                )}
              </div>
            ),
          }}
        />
      )}
      renderOption={(opt) => (
        <Box display="flex" alignItems="center">
          {/* Show "name (id)" in the dropdown options */}
          {module === "managedByModalListing" || module === "managedByListing"
            ? `${opt.name} (${opt.id})`
            : opt.name}
        </Box>
      )}
    />
  );
}
